(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tool-beast-heated-gear"] && !Shopify.designMode) return;
  try {
    
  function initializeHeatedGear(root) {
    if (!root || root.dataset.heatedGearReady === 'true') return;

    const buttons = Array.from(root.querySelectorAll('[data-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-product-card]'));
    const status = root.querySelector('[data-filter-status]');

    if (!buttons.length || !cards.length) return;

    root.dataset.heatedGearReady = 'true';

    function applyFilter(filter, label) {
      let visibleCount = 0;

      cards.forEach((card) => {
        const showCard = filter === 'all' || card.dataset.category === filter;
        card.hidden = !showCard;
        if (showCard) visibleCount += 1;
      });

      buttons.forEach((button) => {
        const isActive = button.dataset.filter === filter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      if (status) {
        const showingLabel = root.dataset.showingLabel || 'Showing';
        const productLabel = root.dataset.productLabel || 'products';
        status.textContent =
          filter === 'all'
            ? `${showingLabel} ${visibleCount} ${productLabel}`
            : `${showingLabel} ${visibleCount} ${label.toLowerCase()} ${productLabel}`;
      }
    }

    buttons.forEach((button) => {
      button.addEventListener('click', () => applyFilter(button.dataset.filter, button.textContent.trim()));
    });

    applyFilter('all', buttons[0].textContent.trim());
  }

  function initializeAllHeatedGear(container) {
    const scope = container || document;
    if (scope.matches && scope.matches('[data-heated-gear]')) {
      initializeHeatedGear(scope);
    }
    scope.querySelectorAll('[data-heated-gear]').forEach(initializeHeatedGear);
  }

  initializeAllHeatedGear(document);

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllHeatedGear(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
